import React, { useState } from "react";
import Customer from "Services/http/customer";
import { translate } from "Translate";
import store from "Store";
import trim from "lodash/trim";
import Cookies from "universal-cookie";
import T from "Translate";
import sendEvent, { EVENT } from "Services/googleAnalytics";

export const formValidator = async values => {
    const errors = {};
    if (!trim(values.firstName)) {
        errors.firstName = <T>{"error_required_field"}</T>;
    }
    if (!trim(values.lastName)) {
        errors.lastName = <T>{"error_required_field"}</T>;
    }
    if (!trim(values.emailAddress)) {
        errors.emailAddress = <T>{"error_required_field"}</T>;
    }
    if (!trim(values.phoneNumber)) {
        errors.phoneNumber = <T>{"error_required_field"}</T>;
    }
    if (!trim(values.password)) {
        errors.password = <T>{"error_required_field"}</T>;
    }
    if (!trim(values.termsCondition)) {
        errors.termsCondition = <T>{"error_required_field"}</T>;
    }

    return errors;
};

export const getSponsorInitialValue = () => {
    const cookies = new Cookies();
    if (store.getState().form.account && store.getState().form.account.values.sponsor) {
        return store.getState().form.account.values.sponsor;
    }
    if (store.getState().form.account && store.getState().form.account.initialValues.sponsor) {
        return store.getState().form.account.values.sponsor;
    }
    return cookies.get("refId");
};

export const getInitialValues = () =>  ({
    firstName: store.getState().form.account && store.getState().form.account.values.firstName,
    lastName: store.getState().form.account && store.getState().form.account.values.lastName,
    fullName: store.getState().form.account && store.getState().form.account.values.fullName,
    emailAddress: store.getState().form.account && store.getState().form.account.values.emailAddress,
    govId: store.getState().form.account && store.getState().form.account.values.govId,
    phoneNumber: store.getState().form.account && store.getState().form.account.values.phoneNumber,
    password: store.getState().form.account && store.getState().form.account.values.password,
    sponsor: getSponsorInitialValue(),
    termsCondition: store.getState().form.account && store.getState().form.account.values.termsCondition,
    privacypolicy: store.getState().form.account && store.getState().form.account.values.privacypolicy,
    captchaToken: store.getState().form.account && store.getState().form.account.values.captchaToken
});

const useFormElements = props => {
    const [showPassword, setShowPassword] = useState(false);
    const [alertErrorMsg, setAlertErrorMsg] = useState("");
    const [open, setOpen] = useState(false);
    const [apiErroredOnCaptcha, setApiErroredOnCaptcha] = useState(null);

    const onSubmit = async values => {
        const countryCode = store.getState().locale.country;
        const errors = {};
        props.dispatchIsLoading(true);

        if (Object.keys(errors).length) {
            props.dispatchIsLoading(false);
            return errors;
        }

        try {
            // Trim every key in form account
            // const account = store.getState().form.account.values
            // for (const key in account) {
            //     if (account[key] && typeof account[key] === "string") account[key] = account[key].trim()
            // }
            // store.getState().form.account.values = account

            if (countryCode === "TH") {
                await Customer.membershipValidate()
                    .then(response => {
                        if (!response.data.success) throw response;
                    })
                    .catch(error => {
                        let errorMsg = "Server Error...";
                        if (!error.data || !error.data.Message) throw errorMsg;
                        errorMsg = error.data.Message.map(msg => translate(msg)).join(" | ");
                        throw errorMsg;
                    });
            }

            await Customer.customerCreateAccountHydra()
                .then(response => {
                    sendEvent(EVENT.FORM_JOIN_SUCCEED, { userId: response.data.id.unicity, sponsorId: response.data.sponsor.id.unicity });
                    props.dispatchIsLoading(false);
                    props.dispatchSetUserData(response.data);
                    props.dispatchSetCompletedStep("/account-setup");
                    props.dispatchResetToken();
                    window.mouseflow.newPageView("/congrats");
                })
                .catch(errorResponse => {
                    let errorMsg = "Server Error...";

                    if (errorResponse.data.error.error_code === "3064") {
                        props.dispatchIsLoading(false);
                        setApiErroredOnCaptcha(<T>{"error_required_field"}</T>);
                        return;
                    }

                    sendEvent(EVENT.FORM_JOIN_SUBMIT_SERVER_ERROR, {
                        response_code: errorResponse.status,
                        error_message: errorResponse.data.error.error_message || errorResponse.data.error.message || errorMsg
                    });

                    if (!errorResponse.data || !errorResponse.data.error) throw errorMsg;
                    const { error } = errorResponse.data;
                    errorMsg = error.error_message;
                    throw errorMsg;
                });
        } catch (errorMsg) {
            props.dispatchIsLoading(false);
            if (!errorMsg) return;
            if (errorMsg === 'Sponsoring_Not_Allowed;Enrolling_Not_Allowed;' && countryCode === 'HK') {
                setAlertErrorMsg(`Your distributor status isn't eligible for operations in Hong Kong`);
            } else {
                setAlertErrorMsg(errorMsg);
            }
            setOpen(true);
        }
    };

    return {
        showPassword,
        setShowPassword,
        alertErrorMsg,
        setAlertErrorMsg,
        open,
        setOpen,
        apiErroredOnCaptcha,
        setApiErroredOnCaptcha,
        onSubmit,
        formValidator,
        getInitialValues
    };
};

export default useFormElements;



// WEBPACK FOOTER //
// ./src/components/StartContainer/hooks/useFormElements.js